import { Chip } from "@heroui/react"

const ErrorChip = ({ errors, setErrors, errorKey, className, color='danger' }) => {
  if (!errors[errorKey]) return 
  return <Chip 
    className={className || 'ml-2'}
    color={color}
    size='sm'
    onClose={setErrors ? () => {
      const newErrors = { ...errors }  
      newErrors[errorKey] = null
      setErrors(newErrors)
    } : null}>
      {errors[errorKey]}
  </Chip>
}

export default ErrorChip
